export default __webpack_public_path__ + "static/globe-with-tags-349449b13778a1a8c438cdcc149fb97f.svg";